<div class="container">
  <div class="row no-gutters">
    <div class="col-12">


      <div class="d-flex popup-head align-items-center">
        <div class="popup-title " translate>lblEditMechanicTimeCode</div>
        <div class="float-right ml-auto">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
        
      </div>

      
      <form [formGroup]="editMechanicTimeCodeForm" (ngSubmit)="onSubmit()">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="row">
                <div class="col-md-6 af-form-group">
                  <label for="dealer"><span translate>lblSelectDealer</span><span class="text-danger"> * </span>
                  </label>
                  <div class="lbl-info">
                    <select formControlName="dealerId"
                      [ngClass]="{'is-invalid': (cpf.dealerId.touched || cpf.dealerId.dirty) && cpf.dealerId.errors}"
                      class="custom-select custom-select mb-2">
                      <option disabled value="" translate>lblSelectDealer</option>
                      <option *ngFor="let dealer of dealerList" [ngValue]="dealer.value">
                        {{dealer.text}}</option>
                    </select>
                    <div *ngIf="(cpf.dealerId.touched || cpf.dealerId.dirty) && cpf.dealerId.errors">
                      <div *ngIf="cpf.dealerId.errors.required || cpf.dealerId.errors.min || cpf.dealerId===-1"
                        class="help-block mt-1 text-danger" translate>
                        lblDealerRequired
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12" *ngIf="t">
                  <div class="row" *ngFor="let ticket of t.controls; let i = index">
                    <div class="col-md-12" [formGroup]="ticket">
                      <div class="row">
                      <div class="col-6 af-form-group">
                        <label for="name" translate>lblTimeCode <span>in {{languageList[i].value}}</span>
                            <strong class="mlt6 required"> * </strong></label>
                        <div class="lbl-info">
                          <input formControlName="name" class="form-control mb-2" maxlength="50"
                            [ngClass]="{'is-invalid': cpf.service.invalid && cpf.service.touched}">
                          <div *ngIf="cpf.service.touched && (cpf.service.errors?.required)"
                            class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                              aria-hidden="true"></em>
                            lblNameRequired
                          </div>
                        </div>
                        <div class="lbl-info" style="display: none;">
                        <input formControlName="languageId" class="form-control mb-2" [ngModel]="languageList[i].id"
                         >
                      </div>
                      </div>
          
                      
          
                      <div class="col-6 af-form-group">
                        <label for="name" translate>lblDescription <span>in {{languageList[i].value}}</span> <strong class="mlt6 required"> * </strong></label>
                        <div class='lbl-info'>
                          <input formControlName="description" class="form-control mb-2"  maxlength="500"
                            [ngClass]="{'is-invalid': cpf.service.invalid && cpf.service.touched}">
                          <div *ngIf="cpf.service.touched && (cpf.service.errors?.required)"
                            class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                              aria-hidden="true"></em>
                            lblTemplateRequired
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 af-form-group">
                  <div class='lbl-info ml-2'>
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="isShowInDWO"
                        formControlName="isShowInDWO">
                      <label class="custom-control-label" for="isShowInDWO" translate>lblDisplayInDWO</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
         
            <div class="d-flex flex-sm-row flex-column justify-content-end">
              <button class="btn btn-primary btn-lg mr-sm-2" aria-label="Center Align" translate [disabled]="!editMechanicTimeCodeForm.valid">
                <em class="far fa-save font16 align-top mr-2"></em> lblSaveChanges</button>
              <a (click)="OnClose()"  type="reset" class="btn btn-lg btn-secondary" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
            </div>
         
        </div>
        
      </form>
    </div>
  </div>
</div>